import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { PrivacySettingsAcceptAction, PrivacySettingsActionsUnion, PrivacySettingsRejectAction } from '../models';

@Component({
  selector: 'mc-cookies-notification-banner',
  templateUrl: './cookies-notification-banner.component.html',
  styleUrls: ['./cookies-notification-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CookiesNotificationBannerComponent {
  @Output() action = new EventEmitter<PrivacySettingsActionsUnion>();

  public acceptCookies(): void {
    this.action.emit(new PrivacySettingsAcceptAction());
  }

  public rejectCookies(): void {
    this.action.emit(new PrivacySettingsRejectAction());
  }
}
